import React from 'react';
import { Row, Col, Form, FormGroup, Input, Label } from 'reactstrap';
import PropTypes from 'prop-types';
import { BODYSITE_BUTTON_GROUPS } from './ConstBodySiteBtns';

BodySiteBtnsView.propTypes = {
  bodySites: PropTypes.arrayOf(PropTypes.string),
  onChangeBodySites: PropTypes.func.isRequired,
};

BodySiteBtnsView.defaultProps = {
  bodySites: []
};

//Displays checkboxes for all the available body sites (in BODYSITE_BUTTON_GROUPS)
//Intended use: include within a <Form> in the parent component
export function BodySiteBtnsView(props) {
  const bodySites = props.bodySites ?? [];
  const onChangeBodySites= props.onChangeBodySites;

  //get the buttons from config structure (a little brittle, but works)
  const UEBtnGroup = BODYSITE_BUTTON_GROUPS[0];
  const leftUEBtns = UEBtnGroup.buttons.slice(0,5);
  const rightUEBtns = UEBtnGroup.buttons.slice(5,10);

  const headBtnGroup = BODYSITE_BUTTON_GROUPS[1];
  const headBtns = headBtnGroup.buttons;

  const speechBtnGroup = BODYSITE_BUTTON_GROUPS[2];
  const speechBtns = speechBtnGroup.buttons;

  const LEBtnGroup = BODYSITE_BUTTON_GROUPS[3];
  const leftLEBtns = LEBtnGroup.buttons.slice(0,4);
  const rightLEBtns = LEBtnGroup.buttons.slice(4,8);

  console.log("rendering BodySiteBtnsView form with bodySites: " + bodySites);
  return(
    <>
      <Row>
        <Col md="6">
          <FormGroup tag="fieldset">
            <legend>{UEBtnGroup.legend}</legend>
            <Row>
              <Col sm="6">
              {leftUEBtns.map((btn, index) =>
                <FormGroup check key={index}>
                  <Input
                    id={btn.value}
                    value={btn.value}
                    checked={bodySites.indexOf(btn.value) > -1}
                    onChange={onChangeBodySites} 
                    name="bodySites"
                    type="checkbox"
                  />
                  {' '}
                  <Label for={btn.value} check>
                    {btn.label}
                    {' '}
                    <span className="aa-more-info">{btn.moreInfo}</span>
                  </Label>
                </FormGroup>
              )}
              </Col>
              <Col sm="6">
              {rightUEBtns.map((btn, index) =>
                <FormGroup check key={index}>
                  <Input
                    id={btn.value}
                    value={btn.value}
                    checked={bodySites.indexOf(btn.value) > -1}
                    onChange={onChangeBodySites} 
                    name="bodySites"
                    type="checkbox"
                  />
                  {' '}
                  <Label for={btn.value} check>
                    {btn.label}
                    {' '}
                    <span className="aa-more-info">{btn.moreInfo}</span>
                  </Label>
                </FormGroup>
              )}
              </Col>
            </Row>
          </FormGroup>
        </Col>
        <Col md={{size: 5, offset: 1}}>
          <FormGroup tag="fieldset">
            <legend>{headBtnGroup.legend}</legend>
            {headBtns.map((btn, index) =>
                <FormGroup check key={index}>
                  <Input
                    id={btn.value}
                    value={btn.value}
                    checked={bodySites.indexOf(btn.value) > -1}
                    onChange={onChangeBodySites} 
                    name="bodySites"
                    type="checkbox"
                  />
                  {' '}
                  <Label for={btn.value} check>
                    {btn.label}
                    {' '}
                    <span className="aa-more-info">{btn.moreInfo}</span>
                  </Label>
                </FormGroup>
              )}
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col md={{size: 5, offset: 1, order: 2}}>
          <FormGroup tag="fieldset">
            <legend>{speechBtnGroup.legend}</legend>
            {speechBtns.map((btn, index) =>
                <FormGroup check key={index}>
                  <Input
                    id={btn.value}
                    value={btn.value}
                    checked={bodySites.indexOf(btn.value) > -1}
                    onChange={onChangeBodySites} 
                    name="bodySites"
                    type="checkbox"
                  />
                  {' '}
                  <Label for={btn.value} check>
                    {btn.label}
                    {' '}
                    <span className="aa-more-info">{btn.moreInfo}</span>
                  </Label>
                </FormGroup>
              )}
          </FormGroup>
        </Col>
        <Col md="6">
          <FormGroup tag="fieldset">
            <legend>{LEBtnGroup.legend}</legend>
            <Row>
              <Col sm="6">
              {leftLEBtns.map((btn, index) =>
                <FormGroup check key={index}>
                  <Input
                    id={btn.value}
                    value={btn.value}
                    checked={bodySites.indexOf(btn.value) > -1}
                    onChange={onChangeBodySites} 
                    name="bodySites"
                    type="checkbox"
                  />
                  {' '}
                  <Label for={btn.value} check>
                    {btn.label}
                    {' '}
                    <span className="aa-more-info">{btn.moreInfo}</span>
                  </Label>
                </FormGroup>
              )}
              </Col>
              <Col sm="6">
              {rightLEBtns.map((btn, index) =>
                <FormGroup check key={index}>
                  <Input
                    id={btn.value}
                    value={btn.value}
                    checked={bodySites.indexOf(btn.value) > -1}
                    onChange={onChangeBodySites} 
                    name="bodySites"
                    type="checkbox"
                  />
                  {' '}
                  <Label for={btn.value} check>
                    {btn.label}
                    {' '}
                    <span className="aa-more-info">{btn.moreInfo}</span>
                  </Label>
                </FormGroup>
              )}
              </Col>
            </Row>
          </FormGroup>
        </Col>
      </Row>
    </>
  );
}


